import React, { useEffect, useState } from 'react';
import { DetailRiskRegisterComp } from '../../components/moleculs';
import axios from '../../library/axios';
import { useParams } from 'react-router-dom';
import { MySwal } from '../../library/swal';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { LoadingAtom } from '../../components/atoms';
import { validationAccess } from "../../helpers/validationAccess"
import { getModule, setHrefWithSlugHook, useNavigateWithSlugHook } from "../../../src/config/routes/guards/slug";
import { getSlug, } from "../../../src/config/routes/guards/slug";
import { notifyApiError, notifyApiLoadError } from '../../helpers/notifyApiError';

const RiskRegisterPage = () => {
  const routeParams = useParams();
  const location = useLocation();
  const navigate = useNavigateWithSlugHook();

  const [search, setSearch] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [itemRiskActivity, setitemRiskActivity] = useState([]);

  const [loadingData, setloadingData] = useState(true);
  const [role, setRole] = useState('');

  const fetchOneRiskActivity = async () => {
    try {
      const options = {
        url: `/activity-targets/show/${routeParams.id}`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data);
      // return false;
      setTimeout(() => {
        setloadingData(false);
      }, 1000);
      setitemRiskActivity(data);
    } catch (err) {
      setloadingData(false);
      notifyApiLoadError(err, 'pages/risk-register/index.fetchOneRiskActivity');
    }
  };

  const fetchListRiskRegister = async () => {
    try {
      const options = {
        url: `/risk-register/list`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data);
      // return false;
      setTimeout(() => {
        setloadingData(false);
      }, 1000);
      setFilterData(data);
    } catch (err) {
      setloadingData(false);
      notifyApiLoadError(err, 'pages/risk-register/index.fetchListRiskRegister');
    }
  };

  const handleHapus = (id) => {
    MySwal.fire({
      title: 'Apa anda yakin menghapus data ini?',
      text: 'Anda tidak akan dapat mengembalikan data ini!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ya, Hapus Data!',
      cancelButtonText: 'Batal',
    }).then((result) => {
      if (result.isConfirmed) {
        const config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
          },
        };

        axios
          .delete(`/activity-targets/delete/${id}`, config)
          .then((res) => {
            // console.log(res)
            // return false
            if (res.status === 200) {
              MySwal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Hapus Item PPS Berhasil!',
              });
              // return false
              setTimeout(() => {
                fetchOneRiskActivity();
              }, 3000);
            }
          })
          .catch((err) => {
            if (err !== '') {
            notifyApiError(err, { context: 'pages/risk-register/index.handleHapus' });
              // err({ err: err?.response?.data || err });
            }
          });
      }
    });
  };

  const fetchOneUser = async () => {
    try {
      const options = {
        url: `/users/detailUser`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      setRole(data?.data?.mapping_user_groups[0]?.group?.namaGroup);
    } catch (err) {
      notifyApiLoadError(err, 'pages/risk-register/index.fetchOneUser');
    }
  };

  const fetchLoginStatus = async () => {
    try {
      await validationAccess(getModule())
      const options = {
        url: `/users/detailUser`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      if (data.login === false) {
        MySwal.fire({
          icon: 'info',
          title: 'Oops, Unauthorize!',
          text: 'Session anda habis, Silahkan login kembali.',
        });

        setTimeout(() => {
          localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
          localStorage.clear();
          setHrefWithSlugHook("/login");
        }, 3000);
      } else {
        // console.log(data?.data?.mapping_groups[0].module.pathModule)
        let check = data?.data?.mapping_groups?.some(
          (mp) => location.pathname == mp?.module?.pathModule
        );

        if (check === false) {
          MySwal.fire({
            icon: 'info',
            title: 'Oops, No Access!',
            text: 'Anda tidak memiliki akses di halaman ini.',
          });

          setTimeout(() => {
            localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
            setHrefWithSlugHook("/login");
          }, 3000);
        }
      }
    } catch (err) {
      notifyApiLoadError(err, 'pages/risk-register/index.fetchLoginStatus');
    }
  };

  useEffect(() => {
    fetchLoginStatus();
    fetchOneUser();
    fetchOneRiskActivity();
    fetchListRiskRegister();
  }, []);

  const handleChangeSearch = (text) => {
    setSearch(text);
  };

  return (
    <>
      {/*begin::Content*/}
      <div
        className="content d-flex flex-column flex-column-fluid"
        id="kt_content"
      >
        {/*begin::Toolbar*/}
        <div className="toolbar" id="kt_toolbar">
          {/*begin::Container*/}
          <div
            id="kt_toolbar_container"
            className="container-fluid d-flex flex-stack"
          >
            {/*begin::Page title*/}
            <div
              data-kt-swapper="true"
              data-kt-swapper-mode="prepend"
              data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
              className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
            >
              {/*begin::Title*/}
              <h1 className="d-flex align-items-center text-dark fw-bolder fs-3 my-1">
                Manajemen Risiko
                {/*begin::Separator*/}
                <span className="h-20px border-gray-200 border-start ms-3 mx-2" />
                {/*end::Separator*/}
                {/*begin::Description*/}
                <small className="text-muted fs-7 fw-bold my-1 ms-1">
                  #SPEAK_VERSI_RS
                </small>
                {/*end::Description*/}
              </h1>
              {/*end::Title*/}
            </div>
            {/*end::Page title*/}
          </div>
          {/*end::Container*/}
        </div>
        {/*end::Toolbar*/}
        {/*begin::Post*/}
        <div className="post d-flex flex-column-fluid" id="kt_post">
          {/*begin::Container*/}
          <div id="kt_content_container" className="container-xxl">
            {/*begin::Row*/}
            <div className="row gy-5 g-xl-8">
              {/*begin::Col*/}
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between mb-5">
                      <div>
                        <h5 className="card-title text-primary">
                          Detail Informasi
                        </h5>
                      </div>
                    </div>
                    {loadingData === true ? (
                      <LoadingAtom />
                    ) : (
                      <>
                        <DetailRiskRegisterComp itemRisk={itemRiskActivity} />
                      </>
                    )}
                  </div>
                </div>
              </div>
              {/*end::Col*/}
            </div>
            {/*end::Row*/}
          </div>
          {/*end::Container*/}
        </div>
        {/*end::Post*/}
      </div>
      {/*end::Content*/}
    </>
  );
};

export default RiskRegisterPage;
